import React from 'react';

const NotificationsPage = () =>
    <div className="container text-center mt-4">You have no new notifications.</div>;

export default NotificationsPage;


// WEBPACK FOOTER //
// ./src/components/notifications/NotificationsPage.jsx